export const SET_GLOBAL_FILTERS_DATA = 'SET_GLOBAL_FILTERS_DATA';
export const SET_SCREEN_FILTERS_DATA = 'SET_SCREEN_FILTERS_DATA';
